document.addEventListener('DOMContentLoaded', function () {
  /* Mobile menu */
  var toggle = document.querySelector('[data-mobile-menu-toggle]');
  var header = document.querySelector('[data-header]');
  if (toggle && header) {
    toggle.addEventListener('click', function () {
      var open = header.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
  }

  /* Carousels (products + reviews). data-carousel-loop = endless */
  document.querySelectorAll('[data-carousel]').forEach(function (root) {
    var track = root.querySelector('[data-carousel-track]');
    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    if (!track) return;
    var loop = root.hasAttribute('data-carousel-loop');
    var slides = Array.prototype.slice.call(track.querySelectorAll('.carousel__slide'));

    function step() {
      var slide = slides[0];
      if (!slide) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    function update() {
      if (loop) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
      root.classList.toggle('is-static', max <= 0);
    }

    /* Endless loop: the list is rendered 3 times; keep the view in the middle copy */
    var setWidth = 0, originals = 0;
    function jumpTo(left) {
      track.scrollTo({ left: left, behavior: 'instant' });
    }
    function measureLoop() {
      originals = slides.length / 3;
      if (!loop || originals < 1 || slides.length % 3 !== 0) { loop = false; return; }
      setWidth = slides[originals].offsetLeft - slides[0].offsetLeft;
    }
    function centerOn(slide) {
      return slide.offsetLeft - (track.clientWidth - slide.offsetWidth) / 2;
    }
    if (loop) {
      measureLoop();
      if (loop) {
        var start = slides[originals + Math.min(1, originals - 1)];
        jumpTo(centerOn(start));
        var t;
        track.addEventListener('scroll', function () {
          clearTimeout(t);
          t = setTimeout(function () {
            if (track.scrollLeft < setWidth * 0.5) jumpTo(track.scrollLeft + setWidth);
            else if (track.scrollLeft > setWidth * 1.5) jumpTo(track.scrollLeft - setWidth);
          }, 140);
        }, { passive: true });
        var lastW = window.innerWidth;
        window.addEventListener('resize', function () {
          if (window.innerWidth === lastW) return; /* ignore mobile URL-bar height changes */
          lastW = window.innerWidth;
          measureLoop();
          jumpTo(centerOn(slides[originals + Math.min(1, originals - 1)]));
        });
      }
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* Page hero video card: swap poster for the player on click */
  document.querySelectorAll('[data-video-card]').forEach(function (card) {
    var btn = card.querySelector('[data-video-play]');
    var tpl = card.querySelector('[data-video-template]');
    if (!btn || !tpl) return;
    btn.addEventListener('click', function () {
      card.appendChild(tpl.content.cloneNode(true));
      btn.remove();
      var v = card.querySelector('video');
      if (v) { v.play().catch(function () {}); }
    });
  });
});
